/**
 * Utility function to get query parameter value from URL
 */
export function getQueryParam(key: string): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
}
